import {
  TOKEN_REFRESH_FAILURE,
  TOKEN_REFRESH_REQUEST,
  TOKEN_REFRESH_RESET,
  TOKEN_REFRESH_SUCCESS,
} from '../actions/token_refresh'

export function refreshAccessToken(
  state = {
    isFetching: true,
    accessToken: null,
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case TOKEN_REFRESH_REQUEST:
      return {
        ...state,
        isFetching: true,
        accessToken: null,
        errorMessage: null,
      }
    case TOKEN_REFRESH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        accessToken: action.response.access_token,
        errorMessage: null,
      }
    case TOKEN_REFRESH_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.error,
      }
    case TOKEN_REFRESH_RESET:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        accessToken: null,
      }
    default:
      return state
  }
}
